"use client";

import { cn } from "@borderless/ui/lib/utils";
import NextLink from "next/link";
import { useEffect, useState } from "react";

interface Section {
  title: string;
  id: string;
}

export function SectionNavigation({ sections }: { sections: Section[] }) {
  const [activeSection, setActiveSection] = useState<string>(
    sections[0]?.id ?? "",
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        rootMargin: "-80px 0px -80% 0px",
      },
    );

    sections.forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  }, [sections]);

  return (
    <div className="sticky top-(--header-height) z-10 flex w-full overflow-x-auto bg-background px-4 whitespace-nowrap md:px-8">
      {sections.map((section) => (
        <NextLink
          key={`link-to-${section.id}`}
          href={`#${section.id}`}
          className={cn(
            "flex-shrink-0 px-4 pt-4 pb-3 text-base font-semibold",
            "border-b-2 transition-colors duration-200",
            activeSection === section.id
              ? "border-b-primary text-primary"
              : "border-b-transparent hover:border-b-primary/50",
          )}
          onClick={() => setActiveSection(section.id)}
        >
          {section.title}
        </NextLink>
      ))}
    </div>
  );
}
